import { colors } from "../libraries/material/core"
import { mimeTypes } from "./enums"
const createClasses = ({ error }) => {
    const { green } = colors
    return {
        dropzone: (theme) => ({
            position: "relative",
            boxShadow: "0 0 0 100vmax rgba(51, 50, 50, 0.767)",
            borderRadius: theme.spacing(),
            padding: "2rem !important",
            margin: "-2rem !important",
            zIndex: 'zIndex.modal'
        }),
        osuFileUpload: {
            paddingTop: "1.1rem",
            paddingBottom: "1.1rem"
        },
        progressCircle: {
            width: "1.5em",
            height: "1.5em"
        },
        fileSuccess: theme => {
            return {
                color: theme.palette.getContrastText(green[300]),
                backgroundColor: green[300],
                '&:hover': {
                    color: theme.palette.getContrastText(green[400]),
                    backgroundColor: green[400],
                }
            }
        },
        deletable: {
            ["&:focus"]: {
                outline: "-webkit-focus-ring-color auto 5px"
            }
        },
        errorAlert: (theme) => {
            return {
                display: error ? "flex" : "none",
                ["&:focus"]: {
                    outline: `${theme.palette.error.main} auto 5px`
                }
            }
        },
    }
}

const createUserFriendlyAcceptString = (accept = "") => {
    let friendlyFileTypes = []
    let parsedFileTypes = accept.replaceAll(" ", "")
    parsedFileTypes = parsedFileTypes.split(",")
    
    parsedFileTypes.forEach(type => {
        let typeToAdd = mimeTypes[type] ?? type
        const matchFound = friendlyFileTypes.filter(currentType => currentType.split(", ").includes(typeToAdd))
        if(matchFound.length === 0) {
            friendlyFileTypes.push(typeToAdd)
        }
    })
    
    return friendlyFileTypes.join(", ")
}

export {
    createClasses,
    createUserFriendlyAcceptString
}